import { useContext } from 'use-context-selector';
import { BreadcrumbsContext } from 'Contexts/BreadcrumbsContext';

export default function useBreadcrumbs() {
  return useContext(BreadcrumbsContext);
}
